import React, { FC } from 'react';
import { Button, HeadingThree } from 'hui';
import { Upload } from 'antd';
import UploadFailed from './UploadFailedPage';
import { UploadProps } from 'antd/es/upload';
import { UploadFile } from 'antd/lib/upload/interface';
import { HeadingWrapper } from './style';

interface UploadAreaProps {
  uploadProps: UploadProps;
  fileList: Array<UploadFile>;
  uploadButtonDisabled: boolean;
  uploadStatus?: string;
  responseDetail?: string[];
  responseFailReason?: string;
}

const UploadArea: FC<UploadAreaProps> = ({
  uploadProps,
  fileList,
  uploadButtonDisabled,
  uploadStatus,
  responseDetail,
  responseFailReason,
}) => (
  <>
    <HeadingWrapper>
      <HeadingThree>1. Upload file</HeadingThree>
    </HeadingWrapper>
    <div>
      <Upload {...uploadProps} fileList={fileList}>
        <Button color="primary" disabled={uploadButtonDisabled}>
          Upload File
        </Button>
      </Upload>
    </div>
    {uploadStatus === 'fail' && (
      <UploadFailed detail={responseDetail} failReason={responseFailReason} />
    )}
  </>
);

export default UploadArea;
